import {
  loadSession,
  getSession,
  AuthType,
} from '~/techstyle-shared/redux-core';

export const isAuthTypeAuthenticated = (authType) => {
  return [AuthType.CREDENTIALS, AuthType.GMS_LOGIN].includes(authType);
};

export const isFullyAuthenticated = async ({ store }) => {
  await store.dispatch(loadSession());
  const { isLoggedIn, authType } = getSession(store.getState());

  return isLoggedIn && isAuthTypeAuthenticated(authType);
};
